/** Where the guest screens live. A guest is named by its GS-### ref in the URL. */
export const GUESTS_PATH = '/guests';
export const GUEST_NEW_PATH = '/guests/new';
export const GUEST_RSVPS_PATH = '/guests/rsvps';

export function guestPath(ref: string | null | undefined): string | undefined {
  return ref ? `${GUESTS_PATH}/${encodeURIComponent(ref)}` : undefined;
}

export function guestEditPath(ref: string): string {
  return `${GUESTS_PATH}/${encodeURIComponent(ref)}/edit`;
}

export type GuestsRoute =
  | { kind: 'list' }
  | { kind: 'new' }
  | { kind: 'rsvps' }
  | { kind: 'profile'; ref: string }
  | { kind: 'edit'; ref: string };

/** Reads a /guests... path. Anything that is not a guest path is null. */
export function matchGuestsRoute(pathname: string): GuestsRoute | null {
  const parts = pathname.split('/').filter(Boolean);
  if (parts[0] !== 'guests') return null;
  if (parts.length === 1) return { kind: 'list' };
  if (parts[1] === 'new' && parts.length === 2) return { kind: 'new' };
  if (parts[1] === 'rsvps' && parts.length === 2) return { kind: 'rsvps' };
  let ref: string;
  try { ref = decodeURIComponent(parts[1]); } catch { return null; }
  if (parts.length === 2) return { kind: 'profile', ref };
  if (parts.length === 3 && parts[2] === 'edit') return { kind: 'edit', ref };
  return null;
}
